import { render, staticRenderFns } from "./AreaAddComponent.vue?vue&type=template&id=394b3d26&scoped=true"
import script from "./AreaAddComponent.vue?vue&type=script&lang=js"
export * from "./AreaAddComponent.vue?vue&type=script&lang=js"
import style0 from "./AreaAddComponent.vue?vue&type=style&index=0&id=394b3d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b3d26",
  null
  
)

export default component.exports